import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';

export const unmappedDataFeedSourcesApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getUnmappedDataFeedSources: build.query({
      query: () => apiUrl.unmappedDataFeedSources,
      transformResponse: (responseData) => ({
        data: responseData.data,
      }),
      providesTags: ['UnmappedDataFeedSources'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetUnmappedDataFeedSourcesQuery, useLazyGetUnmappedDataFeedSourcesQuery } =
  unmappedDataFeedSourcesApi;
